import React, { Component } from "react";
import { submitJob, notification } from "../services";

const INITIAL_STATE = {
  instructions: "",
  xlsx: false,
  csv: false,
  json: true,
  api: false,
  other: false,
  other_format: "",
  estimatedVolume: "",
  submitting: false,
  errors: []
};

class CreateJob extends Component {
  state = INITIAL_STATE;
  onChange = e => {
    let value;
    if (e.target.type === "checkbox") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    this.setState({ [e.target.name]: value });
  };

  valid() {
    let errors = [];
    if (this.state.instructions === "") {
      errors.push("Instruction are required");
    }
    if (this.state.estimatedVolume === "") {
      errors.push("Estimated Volume is required");
    }
    if (
      !this.state.xlsx &&
      !this.state.csv &&
      !this.state.json &&
      !this.state.api
    ) {
      errors.push("At-least one output format should be selected");
    }
    this.setState({ errors: errors });
    return errors.length === 0;
  }

  clearErrors() {
    this.setState({ errors: [] });
  }

  clearForm() {
    setTimeout(() => {
      this.setState(INITIAL_STATE);
    }, 500);
  }
  lockForm() {
    this.setState({ submitting: true });
  }
  unLockForm() {
    this.setState({ submitting: false });
  }
  createJob = () => {
    this.clearErrors();
    if (!this.valid()) {
      return;
    }
    this.lockForm();
    submitJob(this.state)
      .then(response => {
        this.unLockForm();
        this.clearForm();
        notification.success("Job Created Successfully");
      })
      .catch(error => {
        console.log(error.response.data);
        let defaultMessage =
          "Job Creation Failed. Please contact Administrator";
        let message = "";
        try {
          message = error.response.data.error.message
            ? "No files found in the inbox. Make sure you've added files in inbox."
            : defaultMessage;
        } catch (err) {
          message = defaultMessage;
        }
        notification.error(message);
        this.unLockForm();
      });
  };

  render() {
    const input = this.state;
    return (
      <div className="job">
        <form id="jobform">
          <h3>Submit Job</h3>
          <label style={{ color: "silver" }}>
            <span style={{ color: "black", fontWeight: "bold" }}>Note: </span>
            Please drag and drop your files into Inbox, then submit a job.
          </label>
          <label>
            <sup>*</sup>Instructions for data fields to extraction
          </label>
          <textarea
            id="instructions"
            name="instructions"
            className="form-control"
            rows="6"
            value={input.instructions}
            onChange={this.onChange}
            disabled={this.state.submitting}
            placeholder="Your instruction goes here..."
          ></textarea>
          <br />
          <label>
            <sup>*</sup>Output Formats
          </label>
          <div className="form-check">
            <input
              name="xlsx"
              type="checkbox"
              className="form-check-input"
              id="xlsx"
              onChange={this.onChange}
              checked={input.xlsx}
              disabled={this.state.submitting}
            />
            <label className="form-check-label" htmlFor="xlsx">
              XLSX
            </label>
          </div>
          <div className="form-check">
            <input
              name="csv"
              type="checkbox"
              className="form-check-input"
              id="csv"
              onChange={this.onChange}
              disabled={this.state.submitting}
              checked={input.csv}
            />
            <label className="form-check-label" htmlFor="csv">
              CSV
            </label>
          </div>
          <div className="form-check">
            <input
              name="json"
              type="checkbox"
              className="form-check-input"
              id="json"
              onChange={this.onChange}
              disabled={this.state.submitting}
              checked={input.json}
            />
            <label className="form-check-label" htmlFor="json">
              JSON
            </label>
          </div>
          <div className="form-check">
            <input
              name="api"
              type="checkbox"
              className="form-check-input"
              id="api"
              onChange={this.onChange}
              disabled={this.state.submitting}
              checked={input.api}
            />
            <label className="form-check-label" htmlFor="api">
              API
            </label>
          </div>
          <div className="form-check">
            <input
              name="other"
              type="checkbox"
              className="form-check-input"
              id="other"
              onChange={this.onChange}
              disabled={this.state.submitting}
              checked={input.other}
            />
            <input
              className="form-control"
              type="text"
              placeholder="Other"
              name="other_format"
              onChange={this.onChange}
              value={input.other_format}
              disabled={this.state.submitting || !this.state.other}
            ></input>
          </div>
          <br />
          <label>
            <sup>*</sup>Estimated Volume
          </label>
          <input
            id="estimated_volume"
            name="estimatedVolume"
            className="form-control"
            type="text"
            placeholder="Pages a month"
            onChange={this.onChange}
            disabled={this.state.submitting}
            value={input.estimatedVolume}
          />
          <br />
          <div id="errors">
            {this.state.errors.map(error => {
              return <li style={{ color: "red" }}>{error}</li>;
            })}
          </div>
          <br />
          <button
            type="button"
            id="submitjob"
            className="btn btn-lg btn-block btn-primary mb-3"
            onClick={this.createJob}
            disabled={this.state.submitting}
          >
            {this.state.submitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    );
  }
}

export default CreateJob;
